import React from 'react';
import PropTypes from 'prop-types';

// @atlakit
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';

const RemoveButton = ({
  content,
  isDisabled,
  onClick,
}) => (
  <Tooltip content={content} position="left">
    <Button
      appearance="subtle"
      iconBefore={<CrossCircleIcon size="small" />}
      isDisabled={isDisabled}
      onClick={onClick}
      spacing="compact"
    />
  </Tooltip>
);

RemoveButton.propTypes = {
  content: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

RemoveButton.defaultProps = {
  isDisabled: false,
};

export default RemoveButton;
